// removed by extract-text-webpack-plugin
module.exports = {"form":"form_168jV","input":"input_2Lm84","radioGroup":"radioGroup_1q1K9","block":"block_zLsbm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/memberData/style.css
 ** module id = 934
 ** module chunks = 0
 **/